/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type MatchType = "ean" | "name" | "sku";

export type SearchUnitsByEanInput = {
  ean: string;
};

export type SearchUnitsByTextInput = {
  query: string;
};

export type SearchUnitsByEanQueryVariables = Exact<{
  searchUnitsByEanInput: Types.SearchUnitsByEanInput;
  isAlwaysInbound?: boolean | null | undefined;
}>;

export type SearchUnitsByEanQuery = {
  searchUnitsByEan: {
    units: Array<{
      ean: string | null;
      id: string;
      productSku: string;
      quantity: number;
      type: string;
      product: {
        bio: boolean | null;
        imageUrl: string | null;
        isShelvedInHandlingUnits: boolean | null;
        name: string;
        numberOfShelfFacings: number | null;
        numberOfShelfStackings: number | null;
        countryOfOrigin: { code: string | null };
        inventoryEntry: { shelfNumber: string | null; stock: { shelf: number } | null };
      };
    }>;
  };
};

export type SearchUnitsByTextQueryVariables = Exact<{
  searchUnitsByTextInput: Types.SearchUnitsByTextInput;
}>;

export type SearchUnitsByTextQuery = {
  searchUnitsByText: {
    matchType: Types.MatchType | null;
    units: Array<{
      ean: string | null;
      id: string;
      productSku: string;
      quantity: number;
      type: string;
      product: {
        bio: boolean | null;
        imageUrl: string | null;
        isShelvedInHandlingUnits: boolean | null;
        name: string;
        numberOfShelfFacings: number | null;
        numberOfShelfStackings: number | null;
        countryOfOrigin: { code: string | null };
        inventoryEntry: { shelfNumber: string | null; stock: { shelf: number } | null };
      };
    }>;
  };
};

export const SearchUnitsByEanDocument = gql`
  query searchUnitsByEan(
    $searchUnitsByEanInput: SearchUnitsByEanInput!
    $isAlwaysInbound: Boolean
  ) {
    searchUnitsByEan(
      searchUnitsByEanInput: $searchUnitsByEanInput
      isAlwaysInbound: $isAlwaysInbound
    ) {
      units {
        ean
        id
        productSku
        quantity
        type
        product {
          bio
          imageUrl
          isShelvedInHandlingUnits
          name
          numberOfShelfFacings
          numberOfShelfStackings
          countryOfOrigin {
            code
          }
          inventoryEntry {
            shelfNumber
            stock {
              shelf
            }
          }
        }
      }
    }
  }
`;

/**
 * __useSearchUnitsByEanQuery__
 *
 * To run a query within a React component, call `useSearchUnitsByEanQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUnitsByEanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUnitsByEanQuery({
 *   variables: {
 *      searchUnitsByEanInput: // value for 'searchUnitsByEanInput'
 *      isAlwaysInbound: // value for 'isAlwaysInbound'
 *   },
 * });
 */
export function useSearchUnitsByEanQuery(
  baseOptions: Apollo.QueryHookOptions<SearchUnitsByEanQuery, SearchUnitsByEanQueryVariables> &
    ({ variables: SearchUnitsByEanQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchUnitsByEanQuery, SearchUnitsByEanQueryVariables>(
    SearchUnitsByEanDocument,
    options,
  );
}
export function useSearchUnitsByEanLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchUnitsByEanQuery, SearchUnitsByEanQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchUnitsByEanQuery, SearchUnitsByEanQueryVariables>(
    SearchUnitsByEanDocument,
    options,
  );
}
// @ts-ignore
export function useSearchUnitsByEanSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchUnitsByEanQuery,
    SearchUnitsByEanQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SearchUnitsByEanQuery, SearchUnitsByEanQueryVariables>;
export function useSearchUnitsByEanSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchUnitsByEanQuery, SearchUnitsByEanQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchUnitsByEanQuery | undefined, SearchUnitsByEanQueryVariables>;
export function useSearchUnitsByEanSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchUnitsByEanQuery, SearchUnitsByEanQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchUnitsByEanQuery, SearchUnitsByEanQueryVariables>(
    SearchUnitsByEanDocument,
    options,
  );
}
export type SearchUnitsByEanQueryHookResult = ReturnType<typeof useSearchUnitsByEanQuery>;
export type SearchUnitsByEanLazyQueryHookResult = ReturnType<typeof useSearchUnitsByEanLazyQuery>;
export type SearchUnitsByEanSuspenseQueryHookResult = ReturnType<
  typeof useSearchUnitsByEanSuspenseQuery
>;
export type SearchUnitsByEanQueryResult = Apollo.QueryResult<
  SearchUnitsByEanQuery,
  SearchUnitsByEanQueryVariables
>;
export const SearchUnitsByTextDocument = gql`
  query searchUnitsByText($searchUnitsByTextInput: SearchUnitsByTextInput!) {
    searchUnitsByText(searchUnitsByTextInput: $searchUnitsByTextInput) {
      matchType
      units {
        ean
        id
        productSku
        quantity
        type
        product {
          bio
          imageUrl
          isShelvedInHandlingUnits
          name
          numberOfShelfFacings
          numberOfShelfStackings
          countryOfOrigin {
            code
          }
          inventoryEntry {
            shelfNumber
            stock {
              shelf
            }
          }
        }
      }
    }
  }
`;

/**
 * __useSearchUnitsByTextQuery__
 *
 * To run a query within a React component, call `useSearchUnitsByTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUnitsByTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUnitsByTextQuery({
 *   variables: {
 *      searchUnitsByTextInput: // value for 'searchUnitsByTextInput'
 *   },
 * });
 */
export function useSearchUnitsByTextQuery(
  baseOptions: Apollo.QueryHookOptions<SearchUnitsByTextQuery, SearchUnitsByTextQueryVariables> &
    ({ variables: SearchUnitsByTextQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchUnitsByTextQuery, SearchUnitsByTextQueryVariables>(
    SearchUnitsByTextDocument,
    options,
  );
}
export function useSearchUnitsByTextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchUnitsByTextQuery,
    SearchUnitsByTextQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchUnitsByTextQuery, SearchUnitsByTextQueryVariables>(
    SearchUnitsByTextDocument,
    options,
  );
}
// @ts-ignore
export function useSearchUnitsByTextSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchUnitsByTextQuery,
    SearchUnitsByTextQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SearchUnitsByTextQuery, SearchUnitsByTextQueryVariables>;
export function useSearchUnitsByTextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchUnitsByTextQuery, SearchUnitsByTextQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  SearchUnitsByTextQuery | undefined,
  SearchUnitsByTextQueryVariables
>;
export function useSearchUnitsByTextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchUnitsByTextQuery, SearchUnitsByTextQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchUnitsByTextQuery, SearchUnitsByTextQueryVariables>(
    SearchUnitsByTextDocument,
    options,
  );
}
export type SearchUnitsByTextQueryHookResult = ReturnType<typeof useSearchUnitsByTextQuery>;
export type SearchUnitsByTextLazyQueryHookResult = ReturnType<typeof useSearchUnitsByTextLazyQuery>;
export type SearchUnitsByTextSuspenseQueryHookResult = ReturnType<
  typeof useSearchUnitsByTextSuspenseQuery
>;
export type SearchUnitsByTextQueryResult = Apollo.QueryResult<
  SearchUnitsByTextQuery,
  SearchUnitsByTextQueryVariables
>;
